import { Outlet } from "react-router-dom";

export default function CommonLayout() {

    return (
        <div className="min-h-screen text-white">
            <main className="">
                <Outlet />
            </main>
        </div>
    );
}
